import { createGlobalStyle } from 'styled-components'

export const MemberGlobalStyles = createGlobalStyle`
  body {
    font-family: 'Noto Sans JP', 'Open Sans', sans-serif;
    color: ${props => props.theme.members.colors.black._100};
  }

  a {
    text-decoration: none;

    &:hover, &:focus {
      text-decoration: none;
    }
  }

  p, h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }

  ul, ol {
    margin: 0;
    padding: 0;
  }
`
